import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/checkbox.scss';
//# sourceMappingURL=index.mjs.map
